import {lazy} from 'react'

// Components

export const SocialStudiesArticlePage = lazy(
  () => import('./../../../../units/social-studies/components/article-page')
)

export const SocialStudiesArticleReadingAssignmentSessionReportHandler = lazy(
  () => import('./../../../../units/social-studies/components/reading-assignment-session-report')
)

export const SocialStudiesAssignArticlePage = lazy(
  () => import('./../../../../units/social-studies/components/assign-article-page')
)

export const SocialStudiesAssignmentsHandler = lazy(
  () => import('./../../../../units/social-studies/common/components/assignments')
)

export const SocialStudiesListingPageContainer = lazy(
  () => import('./../../../../units/social-studies/components/listing-page')
)

export const SocialStudiesSearchOrListingPage = lazy(
  () => import('./../../../../units/social-studies/components/search-or-listing')
)

export const SocialStudiesUnitPageHandler = lazy(
  () => import('./../../../../units/social-studies/components/unit-page')
)

export const SocialStudiesWritingAssignmentReportHandler = lazy(
  () => import('./../../../../units/social-studies/components/writing-assignment-session-report')
)

export const SocialStudiesReportsOverviewHandler = lazy(
  () => import('./../../../../units/social-studies/components/social-studies-reports-overview')
)
